import { isDemoSite } from "./demoSite";
import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Navigate, Route, HashRouter, Routes } from "react-router-dom";
import { AppShell } from "./shell/AppShell";
import { CompatPage } from "./routes/CompatPage";
import { HomePage } from "./routes/HomePage";
import { TeacherEntryPage } from "./routes/TeacherEntryPage";
import { TeacherDashboardPage } from "./features/dashboard/TeacherDashboardPage";
import { ResultPage } from "./features/result/ResultPage";
import "./styles.css";

const StudentDemoPage = lazy(() => import("./features/result/StudentDemoPage"));

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/compat" element={<CompatPage />} />
          <Route path="/t/:token" element={<TeacherEntryPage />} />
          <Route path="/r/:runId" element={<ResultPage />} />
          <Route path="/student-demo" element={isDemoSite ? <Suspense fallback={<p role="status">正在加载学生演示…</p>}><StudentDemoPage /></Suspense> : <Navigate to="/" replace />} />
          <Route path="/teacher-demo" element={isDemoSite ? <TeacherDashboardPage key="demo" demoOnly /> : <Navigate to="/" replace />} />
          <Route path="/teacher/dashboard" element={<TeacherDashboardPage key="live" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </HashRouter>
  </React.StrictMode>
);
